<mat-card class="custom-mat-card-firma">
    <mat-card-header>
        <mat-card-title>{{datosFirma.documentoNombre}}</mat-card-title>
        <mat-card-subtitle>{{fechaActual | date}}</mat-card-subtitle>
    </mat-card-header>
    <div class="row" style="text-align: center">
        <div class="sig-container">
            <signature-pad
                [options]="signaturePadOptions"
                (onBeginEvent)="drawStart()"
                (onEndEvent)="drawComplete()"
            ></signature-pad>
        </div>
        <mat-card-actions>
            <button mat-stroked-button  (click)="limpiarFirma()">Limpiar</button>
        </mat-card-actions>
        <mat-card-title>{{datosFirma.nombreInterviniente}}</mat-card-title>
    </div>
    <mat-card-content >
        <label>{{datosFirma.leyendaTitulo}}</label>
        <p>{{datosFirma.leyendaCuerpo}}</p>
    </mat-card-content>
    <div class="row" style="text-align: right">
        <button  mat-raised-button color="accent" [disabled]="!validForm" (click)="save()">Guardar</button>
    </div>
</mat-card>





